import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Início',
    component: () => import('@/views/SubjectsView.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/SubjectsView.vue')
  },
  // {
  //   path: '/auth',
  //   name: 'Autenticação',
  //   component: () => import('@/views/LoginView.vue')
  // },
  // {
  //   path: '/about',
  //   name: 'Sobre',
  //   component: () => import('@/views/AboutView.vue')
  // },
  // {
  //   path: '/profile/account',
  //   name: 'Perfil',
  //   component: () => import('@/views/ProfileView.vue')
  // },
  {
    path: '/notification',
    name: 'Notificação',
    component: () => import('@/views/NotificationView.vue')
  },
  {
    path: '/subjects',
    name: 'Disciplinas',
    component: () => import('@/views/SubjectsView.vue')
  },
  {
    path: '/subject/:id_subject',
    name: 'Disciplina',
    component: () => import('@/views/SubjectView.vue')
  },
  {
    path: '/aula/:idaula',
    name: 'Aula',
    component: () => import('@/views/AulaView.vue')
  },
  {
    path: '/avaliacoes',
    name: 'Avaliações',
    component: () => import('@/views/AvaliacoesView.vue')
  },
  {
    path: '/documentos',
    name: 'Documentos',
    component: () => import('@/views/DocumentosView.vue')
  },
  {
    path: '/password-reset/:tokenPass?',
    name: 'Redefinir Senha',
    component: () => import('@/views/PasswordResetView.vue')
  },
  {
    path: '/faq',
    name: 'F.A.Q',
    component: () => import('@/views/FaqView.vue')
  },
  {
    path: '/coordinators',
    name: 'Coordenadores',
    component: () => import('@/views/CoordinatorsView.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Error 404',
    component: () => import('@/views/Error404.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
    
      return {
        el: to.hash,
        behavior: 'smooth',
        top: 100
      }
    } else {
      return { x: 0, y: 0 };
    }
  },
})

router.beforeEach((to, from, next) => {
  document.title = `${to.name} | ${process.env.VUE_APP_TITLE}`
  window.scrollTo(0, 0) // Isso fará a rolagem para o topo da página
  next()
})
export default router
